<template>
  <div v-if="project && pages" class="short-teaser-print">
    <ShortTeaserPrintPage1
      :page-number="currentPage()"
      :page-count="shortTeaserPageCount"
      :project="project"
    />
    <ShortTeaserPrintPage2
      :page-number="currentPage()"
      :page-count="shortTeaserPageCount"
      :project="project"
    />
    <ShortTeaserPrintPage3
      :page-number="currentPage()"
      :page-count="shortTeaserPageCount"
      :project="project"
    />
    <ShortTeaserPrintPage4
      :page-number="currentPage()"
      :page-count="shortTeaserPageCount"
      :project="project"
    />
    <ShortTeaserPrintPage5
      :page-number="currentPage()"
      :page-count="shortTeaserPageCount"
      :project="project"
    />
  </div>
  <div v-else>{{ $t('no_data_found') }}</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { ExtendedProject } from '@/helpers/projects';
import ShortTeaserPrintPage1 from '@/views/ShortTeaser/ShortTeaserPrintPage1';
import ShortTeaserPrintPage2 from '@/views/ShortTeaser/ShortTeaserPrintPage2';
import ShortTeaserPrintPage3 from '@/views/ShortTeaser/ShortTeaserPrintPage3';
import ShortTeaserPrintPage4 from '@/views/ShortTeaser/ShortTeaserPrintPage4';
import ShortTeaserPrintPage5 from '@/views/ShortTeaser/ShortTeaserPrintPage5';

const SHORT_TEASER_PRINT_PAGE_COUNT = 5;

export default {
  components: {
    ShortTeaserPrintPage1,
    ShortTeaserPrintPage2,
    ShortTeaserPrintPage3,
    ShortTeaserPrintPage4,
    ShortTeaserPrintPage5,
  },

  props: {
    projectNumber: {
      required: true,
      default: null,
    },
  },

  data() {
    return {
      number: null,
    };
  },

  computed: {
    ...mapGetters(['getProjectByNumber']),
    pages() {
      return true;
    },
    shortTeaserPageCount() {
      return SHORT_TEASER_PRINT_PAGE_COUNT;
    },
    project() {
      const project = this.getProjectByNumber(this.number);
      if (project) {
        new ExtendedProject(project);
      }
      return project;
    },
  },

  methods: {
    ...mapActions(['fetchProjectByNumber']),
    currentPage() {
      this.pageCounter += 1;
      return this.pageCounter;
    },
  },

  async mounted() {
    this.number = this.projectNumber;
    await this.fetchProjectByNumber(this.number);
  },

  created() {
    this.pageCounter = 0;
  },
};
</script>

<style lang="scss">
.short-teaser-print {
  position: absolute;
  inset: 0;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  font-size: 12pt;
  line-height: 1.45;
}

.short-teaser-print ul {
  margin: 0;
}

.short-teaser-print .page.A4Landscape {
  display: flex;
  flex-direction: column;
}

.short-teaser-print .print-page-landscape__header {
  flex: 0 0 auto;
}

.short-teaser-print .print-page-landscape__main {
  flex: 1 1 auto;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

.short-teaser-start__header {
  padding: 0.6cm 1.5cm 0;
  text-align: center;
}

.short-teaser-start__logoLink {
  display: inline-block;
  line-height: 0;
}

.short-teaser-start__logoImage {
  max-width: min(340px, 85vw);
  width: auto;
  height: auto;
  vertical-align: top;
}

.short-teaser-start__tagline {
  margin-top: 0.35cm;
  margin-bottom: 0;
  font-size: 11pt;
  font-weight: 600;
  letter-spacing: 0.08em;
  color: #1a3a72;
}

.short-teaser-start__main {
  flex: 1 1 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.5cm 2cm 1.75cm;
  box-sizing: border-box;
}

.short-teaser-start__card {
  background: white;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.12);
  padding: 1.65cm 2.75cm;
  text-align: center;
  box-sizing: border-box;
}

.short-teaser-start__customerName {
  margin: 0;
  padding-bottom: 0.35rem;
  border-bottom: 2px solid #111;
  display: inline-block;
  font-size: 26pt;
  font-weight: 700;
}

.short-teaser-start__projectCaption {
  margin: 0.75rem 0 0;
  font-size: 14pt;
  font-weight: 400;
  color: #222;
}

.short-teaser-inner-page {
  width: 100%;
  flex: 1 1 auto;
  box-sizing: border-box;
  padding: 1cm 2cm 1.75cm;
}

.short-teaser-inner-page__heading {
  margin: 1cm 0 0 0.85cm;
  font-size: 30pt;
  font-weight: 500;
  flex-shrink: 0;
}

.short-teaser-inner-page__main {
  font-size: 18pt;
  line-height: 1.55;
  margin: 1cm 0 0 1cm;
}

.short-teaser-inner-page__list {
  margin: 0;
}

.short-teaser-inner-page__list li {
  white-space: pre-line;
}

.short-teaser-inner-page__list li + li {
  margin-top: 0.55em;
}

/* Folie Standort — ShortTeaserPrintPage3 hero uses modifier --location-hero below */

.short-teaser-inner-page__figure {
  margin: 0;
  height: 100%;
  width: 100%;
}

.short-teaser-inner-page__photo {
  display: block;
  max-width: 100%;
  width: auto;
  height: auto;
  margin: 0 auto;
  object-fit: contain;
}

/* Folie Standort — ShortTeaserPrintPage3: flex column so hero photo fills remaining height (padding + h2 from shared .short-teaser-inner-page / __heading) */
.short-teaser-print .short-teaser-inner-page.short-teaser-inner-page--location-hero {
  display: flex;
  flex-direction: column;
  min-height: 0;
}

.short-teaser-print .short-teaser-inner-page--location-hero .short-teaser-inner-page__main {
  flex: 1 1 auto;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

.short-teaser-print .short-teaser-inner-page--location-hero .short-teaser-inner-page__figure {
  flex: 1 1 auto;
  min-height: 0;
  position: relative;
}

.short-teaser-print .short-teaser-inner-page--location-hero .short-teaser-inner-page__photo {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  margin: 0;
  display: block;
  object-fit: contain;
}

/* Technische Daten — ShortTeaserPrintPage4 */
.short-teaser-technical-table {
  width: 100%;
  max-width: 25cm;
  margin-left: 0;
  margin-right: auto;
  border-collapse: collapse;
  border-spacing: 0;
}

.short-teaser-technical-table .short-teaser-technical-table__cell {
  padding: 0.4em 0.65em;
  font-weight: normal;
  border: 1px solid #fff;
}

.short-teaser-technical-table .short-teaser-technical-table__cell--headInformation,
.short-teaser-technical-table .short-teaser-technical-table__cell--headData {
  background-color: #1a3a72;
  color: #fff;
  font-weight: 700;
  text-align: left;
}

.short-teaser-technical-table .short-teaser-technical-table__cell--headData {
  text-align: center;
}

.short-teaser-technical-table tbody .short-teaser-technical-table__cell--informationColumn {
  text-align: left;
  vertical-align: middle;
  background-color: #dedede;
}

.short-teaser-technical-table tbody .short-teaser-technical-table__cell--dataColumn {
  background-color: #ededed;
  text-align: center;
  vertical-align: middle;
}
</style>
